import { createActionGroup, props } from '@ngrx/store';
import { AsistenciaResumen } from './asistencia.state';

export const AsistenciaActions = createActionGroup({
  source: 'Asistencia',
  events: {
    'Load Asistencia': props<{ studentId: string }>(),
    'Load Asistencia Success': props<{ registros: AsistenciaResumen[] }>(),
    'Load Asistencia Failure': props<{ error: string }>(),
  },
});
